module.exports = __webpack_public_path__ + "static/media/albumTwo.48007d14.jfif";